import { useQuery } from '@tanstack/react-query';
import { availableAdvancesQueryKey } from './keys';
import type { AdvancesHttpRequest, SupplierOpenBalanceDto } from '../types';

export interface UseAvailableAdvancesParams {
  documentId: string;
  /** Endpoint GET de saldos disponibles (`/documents/{id}/available-advances`). */
  availableAdvancesEndpoint: string;
  httpRequest: AdvancesHttpRequest;
  enabled?: boolean;
}

/**
 * Lista los saldos de anticipo disponibles para el documento.
 *
 * Cache key: `['available-advances', documentId]`.
 * Array vacío (200) es un estado válido: el documento no tiene saldos.
 */
export function useAvailableAdvances({
  documentId,
  availableAdvancesEndpoint,
  httpRequest,
  enabled = true,
}: UseAvailableAdvancesParams) {
  return useQuery<SupplierOpenBalanceDto[]>({
    queryKey: availableAdvancesQueryKey(documentId),
    enabled: enabled && Boolean(documentId),
    queryFn: async () => {
      const data = await httpRequest<SupplierOpenBalanceDto[]>('GET', availableAdvancesEndpoint);
      return data ?? [];
    },
  });
}
